if (!window.__nlCartUpsell) {
  window.__nlCartUpsell = true;
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-nl-up-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;
    const label = btn.textContent;
    btn.textContent = 'Agregando…';
    const id = btn.getAttribute('data-nl-up-add');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let ev = null, deferred = null;
    try {
      ev = await import('@shopify/events');
      deferred = ev.CartLinesUpdateEvent.createPromise();
      btn.dispatchEvent(new ev.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }], promise: deferred.promise }));
    } catch (err) { ev = null; deferred = null; }
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-drawer-section' }) });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      if (!ev || !deferred) { location.reload(); return; }
      const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      deferred.resolve({ cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: cart.item_count, sections: data.sections, source: 'nalera-cart-upsell', didError: false } });
      setTimeout(() => { if (document.body.contains(btn) && btn.disabled) location.reload(); }, 2500);
    } catch (err) {
      console.error('[nalera-upsell]', err);
      if (deferred) { try { deferred.reject(err); } catch (_) {} }
      btn.disabled = false;
      btn.textContent = label;
    }
  }, true);
}
